Do you want to delete "{{this.data.layerLabel}}"?
<mat-dialog-actions style="position: relative">
  <button class="yesButton" mat-button mat-dialog-close mat-dialog-close="true">Yes</button>
  <button class="noButton" mat-button mat-dialog-close mat-dialog-close="false">No</button>
</mat-dialog-actions>